// Notification translations used by NotificationsService / SideBarNotification / backDebugger.
// Keys are looked up at runtime from notification.type, so they cannot be inlined.

export const NotificationsDictionary: Record<string, any> = {
  "NOTIFICATION_METHOD": "Método de notificación",
  "NOTIFICATION_TITLE_shipmentCreated": "¡Nuevo Embarque!",
  "NOTIFICATION_TITLE_bidUpdated": "Nueva ContraOferta",
  "NOTIFICATION_TITLE_bidSent": "Oferta enviada",
  "NOTIFICATION_TITLE_bidAccepted": "Oferta aceptada",
  "NOTIFICATION_TITLE_bidDeclined": "Oferta rechazada",
  "NOTIFICATION_TITLE_documentAccepted": "Actualización del Embarque",
  "NOTIFICATION_TITLE_documentsAccepted": "¡Documentos firmados!",
  "NOTIFICATION_TITLE_documentDeclined": "¡Documento(s) rechazado(s)!",
  "NOTIFICATION_TITLE_shipmentDelivered": "¡Embarque entregado!",
  "NOTIFICATION_TITLE_driverIsNear": "Actualización del Embarque",
  "NOTIFICATION_TITLE_driverProximityDetected": "Proximidad detectada",
  "NOTIFICATION_TITLE_driverAlert_accident": "¡Hay un accidente cerca de ti!",
  "NOTIFICATION_TITLE_driverAlert_traffic": "¡Hay un atasco de tráfico cerca de ti!",
  "NOTIFICATION_TITLE_shipmentReadyForPickup": "Reserva Completada",
  "NOTIFICATION_TITLE_driverAttached": "¡Enviado! {{uniqueId}}",
  "NOTIFICATION_TITLE_transactionReady": "¡Tu transacción ha sido confirmada!",
  "NOTIFICATION_TITLE_transactionFailure": "Su transacción ha fallado.",
  "NOTIFICATION_TITLE_shipmentStageChange": "{{status}}",
  "NOTIFICATION_TITLE_auctionEnd": "¡Una de sus negociaciones de Embarque ha terminado!",
  "NOTIFICATION_TITLE_auctionStart": "¡Has recibido una nueva oferta!",
  "NOTIFICATION_TITLE_customerInvitationAccepted": "¡La empresa que invitó aceptó ser su cliente!",
  "NOTIFICATION_TITLE_brokerInvitationAccepted": "¡Tienes un nuevo Intermediario!",
  "NOTIFICATION_TITLE_customerInvitationDeclined": "Su invitación de cliente ha sido rechazada",
  "NOTIFICATION_TITLE_brokerInvitationDeclined": "Ha rechazado la invitación de un cliente",
  "NOTIFICATION_TITLE_Dexmiles-earning-actions": "",
  "NOTIFICATION_TITLE_paymentMethodMissing": "SUS PAGOS ESTÁN INHABILITADOS - Actualice sus métodos de pago",
  "NOTIFICATION_TITLE_microdepositVerified": "Su cuenta de plaid fue verificada usando microdepósitos.",
  "NOTIFICATION_TITLE_microdepositExpired": "La verificación de su cuenta de plaid caducó y no se pudo agregar a la plataforma.",
  "NOTIFICATION_TITLE_shipmentBooked": "Actualización del Embarque",
  "NOTIFICATION_TITLE_shipmentEdit": "Ediciones de nuevos Embarques",
  "NOTIFICATION_TITLE_reAcceptShipment": "Ediciones de nuevos Embarques",
  "NOTIFICATION_TITLE_reAcceptShipper": "Ediciones de nuevos Embarques",
  "NOTIFICATION_TITLE_nochargeMoneyToShipper": "Sin cobrar dinero al remitente",
  "NOTIFICATION_TITLE_chargeMoneyToShipper": "Embarque rechazado",
  "NOTIFICATION_TITLE_AceeptNegotiation": "Flete en falso aprobado",
  "NOTIFICATION_TITLE_changeValueShipper": "Flete en falso actualizado",
  "NOTIFICATION_TITLE_shipmentStateNew": "Ediciones de nuevos Embarques",
  "NOTIFICATION_TITLE_shipmentUpdated": "el Embarque fue actualizado",
  "NOTIFICATION_TITLE_validationOboardingBid": "Confirme la tarifa final",
  "NOTIFICATION_TITLE_addOriginDestination": "Agregue Origen y Destino",
  "NOTIFICATION_TITLE_createShipment": "Crear Embarque",
  "NOTIFICATION_TITLE_addDriver": "Agrerar Operador",
  "NOTIFICATION_TITLE_agreement": "Guardar Términos y Condiciones",
  "NOTIFICATION_TITLE_editShipmentCommunicationCenter": "Editar el Embarque",
  "NOTIFICATION_TITLE_newBooking": "Tienes una nueva reserva",
  "NOTIFICATION_TITLE_activateTracking": "Active su rastreo",
  "NOTIFICATION_TITLE_driverAssigned": "Operador asignado",
  "NOTIFICATION_TITLE_driverChanged": "Operador actualizado",
  "NOTIFICATION_TITLE_originDestinationAssigned": "Origen y destino agregados",
  "NOTIFICATION_TITLE_originDestinationChanged": "Origen y destino actualizados",
  "NOTIFICATION_TITLE_documentSigned": "Documento firmado",
  "NOTIFICATION_TITLE_extraChargeCreated": "¡Nuevo cargo adicional agregado!",
  "NOTIFICATION_TITLE_extraChargeAccepted": "Cargo adicional aceptado",
  "NOTIFICATION_TITLE_extraChargeCounterOffer": "ContraOferta Cargo adicional ",
  "NOTIFICATION_TITLE_extraChargeShipperCreated": "Cargo adicional al Remitente creado",
  "NOTIFICATION_TITLE_extraChargeDrayageCreated": "¡Nuevo cargo adicional agregado!",
  "NOTIFICATION_TITLE_extraChargeDrayageAccepted": "Cargo adicional aceptado",
  "NOTIFICATION_TITLE_extraChargeDrayageCounterOffer": "ContraOferta Cargo adicional",
  "NOTIFICATION_TITLE_extraChargeShipperDrayageCreated": "Cargo adicional al Remitente creado",
  "NOTIFICATION_TITLE_auctionStartDrayage": "¡Has recibido una nueva oferta!",
  "NOTIFICATION_TITLE_bidAcceptedDrayage": "Su oferta fue aceptada",
  "NOTIFICATION_TITLE_createDrayage": "Crear Embarque",
  "NOTIFICATION_TITLE_steamshipUpdatedDrayage": "Naviera actualizada",
  "NOTIFICATION_TITLE_containerUpdatedDrayage": "Contenedor actualizado",
  "NOTIFICATION_TITLE_documentsAcceptedDrayage": "¡Documentos firmados!",
  "NOTIFICATION_TITLE_agreementDrayage": "Guardar Términos y Condiciones",
  "NOTIFICATION_TITLE_documentSignedDrayage": "Documento firmado",
  "NOTIFICATION_TITLE_shipmentInfoUpdatedDrayage": "Embarque actualizado",
  "NOTIFICATION_TITLE_inviteCarrier": "¡Invitación a un nuevo Embarque!",
  "NOTIFICATION_TITLE_hash-generated": "Nuevo hash generado",
  "NOTIFICATION_TITLE_auctionStartDrayageCarrier": "¡Oferta enviada con éxito!",
  "NOTIFICATION_TITLE_trackingDrayage": "¡El estado de su contenedor ha cambiado a {{status}}!",
  "NOTIFICATION_TITLE_deliveredDrayage": "Su carga ha sido entregada | [{{uniqueId}}]",
  "NOTIFICATION_TITLE_extraChargeShipperRemoved": "¡Cargo adicional eliminado!",
  "NOTIFICATION_TITLE_documentSignedRate": "Confirmación de la tarifa firmada",
  "NOTIFICATION_TITLE_toBook": "Cotización Automática | {{uniqueId}}",
  "NOTIFICATION_TITLE_updateStateCancelShipment": "Embarque cancelado",
  "NOTIFICATION_TITLE_cancelShipment": "Embarque cancelado",
  "NOTIFICATION_TITLE_issueReport": "Problema reportado!",
  "NOTIFICATION_TITLE_addendumAccepted": "¡Nuevos Términos y Condiciones aceptado!",
  "NOTIFICATION_TITLE_trackingReminder": "¡Acción necesaria!",
  "NOTIFICATION_TITLE_newAgreementUploaded": "Términos y Condiciones subido",
  "NOTIFICATION_TITLE_newAgreementAccepted": "Términos y Condiciones aceptado",
  "NOTIFICATION_TITLE_duplicateShipmentB2B": "Embarque duplicado",
  "NOTIFICATION_TITLE_auctionStartSilent": "¡Has recibido una nueva oferta!",
  "NOTIFICATION_TITLE_bidAcceptedSilent": "Oferta aceptada",
  "NOTIFICATION_TITLE_messageChat": "Nuevo Mensaje",
  "NOTIFICATION_TITLE_chatDrayageNegotiation": "¡Oferta enviada con éxito!",
  "NOTIFICATION_TITLE_bidAcceptedDrayageChat": "Su oferta fue aceptada",
  "NOTIFICATION_TITLE_chatDrayage": "¡Oferta enviada con éxito!",
  "NOTIFICATION_TITLE_bidDeclinedDrayage": "Oferta rechazada",
  "NOTIFICATION_TITLE_trackingDrayageSilent": "¡El estado de su contenedor ha cambiado a {{status}}!",
  "NOTIFICATION_TITLE_confirmFinalCharges": "Cargos finales",
  "NOTIFICATION_TITLE_informationEditDrayage": "Carga actualizada",
  "NOTIFICATION_TITLE_informationEditDrayageSilent": "Se edita el Flete",
  "NOTIFICATION_TITLE_editServicesDrayages": "Nueva tarifa final de Flete",
  "NOTIFICATION_TITLE_acceptedServicesDrayages": "Nueva tarifa final aceptada",
  "NOTIFICATION_TITLE_generateDrayageInvoice": "Nueva Factura",
  "NOTIFICATION_TITLE_bidAcceptedDrayageLog": "Su oferta fue aceptada",
  "NOTIFICATION_TITLE_driverReassigne": "Reasignar Operador",
  "NOTIFICATION_TITLE_negotiatedServicesDrayages": "Servicios de Flete negociados",
  "NOTIFICATION_TITLE_declinedServicesDrayages": "Servicios de Flete rechazados",
  "NOTIFICATION_TITLE_generateBol": "Carta de instrucción generada",
  "NOTIFICATION_TITLE_agreementDrayageLog": "Documento firmado",
  "NOTIFICATION_TITLE_trackingDrayageLog": "¡El estado de su contenedor ha cambiado a {{status}}!",
  "NOTIFICATION_TITLE_driverAssignedLog": "Operador asignado",
  "NOTIFICATION_shipmentCreated": "{{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}})",
  "NOTIFICATION_bidUpdated": "${{value}}, {{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}}) por {{company_name}}.",
  "NOTIFICATION_bidSent": "¡Tu oferta ha sido enviada!",
  "NOTIFICATION_bidAccepted": "${{value}}, {{from}} ({{origin_state}}) a {{to}} ({{destination_state}})",
  "NOTIFICATION_bidDeclined": "${{ratevalue}} - {{pickupDate}} {{originCity}}, {{originState}} - {{destinationCity}} , {{destinationState}}",
  "NOTIFICATION_documentAccepted": "¡Tu documento ha sido aprobado!",
  "NOTIFICATION_documentsAccepted": "{{company}} firmó todos los documentos",
  "NOTIFICATION_documentDeclined": "{{company}} rechazó su(s) documento(s).",
  "NOTIFICATION_shipmentDelivered": "{{origin_city}}, {{origin_state}} a {{destination_city}}, {{destination_state}} | {{carrier_company}}",
  "NOTIFICATION_driverIsNear": "¡El operador de su Embarque está cerca de su destino!",
  "NOTIFICATION_driverProximityDetected": "Detectamos que está cerca de su destino, asegúrese de cambiar la etapa de rastreo cuando llegue.",
  "NOTIFICATION_driverAlert_accident": "",
  "NOTIFICATION_driverAlert_traffic": "",
  "NOTIFICATION_shipmentReadyForPickup": "${{value}}, {{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}})",
  "NOTIFICATION_driverAttached": "Operador asignado para {{origin_city}}, {{origin_state}} a {{destination_city}} {{destination_state}} {{pickup_date}}",
  "NOTIFICATION_transactionReady": "Su {{event}}",
  "NOTIFICATION_transactionFailure": "",
  "NOTIFICATION_shipmentStageChange": "{{origin_city}}, {{origin_state}} a {{destination_city}}, {{destination_state}}",
  "NOTIFICATION_auctionEnd": "",
  "NOTIFICATION_auctionStart": "${{value}}, {{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}})",
  "NOTIFICATION_customerInvitationAccepted": "",
  "NOTIFICATION_brokerInvitationAccepted": "",
  "NOTIFICATION_customerInvitationDeclined": "",
  "NOTIFICATION_brokerInvitationDeclined": "",
  "NOTIFICATION_Dexmiles-earning-actions": "",
  "NOTIFICATION_paymentMethodMissing": "",
  "NOTIFICATION_microdepositVerified": "",
  "NOTIFICATION_microdepositExpired": "",
  "NOTIFICATION_shipmentBooked": "¡Su Embarque está completamente reservado!",
  "NOTIFICATION_shipmentEdit": "{{broker_company}} realizó algunos cambios en su oferta.",
  "NOTIFICATION_reAcceptShipment": "{{carrier_company}} aceptó sus cambios.",
  "NOTIFICATION_reAcceptShipper": "{{broker_company}} aceptó sus cambios.",
  "NOTIFICATION_nochargeMoneyToShipper": "",
  "NOTIFICATION_chargeMoneyToShipper": "Se aplicó la tarifa de Flete en falso después de que {{carrier_company}} rechazara su Embarque.",
  "NOTIFICATION_AceeptNegotiation": "{{company_name}} aceptó su tarifa final anterior.",
  "NOTIFICATION_changeValueShipper": "{{broker_company}} cambió su tarifa final anterior.",
  "NOTIFICATION_shipmentStateNew": "{{carrier_company}} rechazó sus cambios.",
  "NOTIFICATION_shipmentUpdated": "",
  "NOTIFICATION_validationOboardingBid": "{{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}}) ${{value}}",
  "NOTIFICATION_addOriginDestination": "",
  "NOTIFICATION_createShipment": "",
  "NOTIFICATION_addDriver": "",
  "NOTIFICATION_agreement": "",
  "NOTIFICATION_editShipmentCommunicationCenter": "",
  "NOTIFICATION_newBooking": "",
  "NOTIFICATION_activateTracking": "",
  "NOTIFICATION_driverAssigned": "Se asignó un operador para {{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}})",
  "NOTIFICATION_driverChanged": "Se asignó un nuevo operador por {{carrier_company}}",
  "NOTIFICATION_originDestinationAssigned": "{{origin_city}} ({{origin_state}}) a {{destination_city}} ({{destination_state}})",
  "NOTIFICATION_originDestinationChanged": "se actualizó el origen y el destino.",
  "NOTIFICATION_documentSigned": "{{company_name}} firmó los Términos y Condiciones",
  "NOTIFICATION_extraChargeCreated": "{{company_name}} agregó un cargo adicional.\n{{from}}, {{origin_state}}, hasta {{to}}, {{destination_state}} {{value}}",
  "NOTIFICATION_extraChargeAccepted": "",
  "NOTIFICATION_extraChargeCounterOffer": "",
  "NOTIFICATION_extraChargeShipperCreated": "",
  "NOTIFICATION_extraChargeDrayageCreated": "{{company_name}} agregó un cargo extra.\n{{from}}, {{origin_state}}, a {{to}}, {{destination_state}} {{value}}",
  "NOTIFICATION_extraChargeDrayageAccepted": "",
  "NOTIFICATION_extraChargeDrayageCounterOffer": "",
  "NOTIFICATION_extraChargeShipperDrayageCreated": "",
  "NOTIFICATION_auctionStartDrayage": "${{value}}, {{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}})",
  "NOTIFICATION_bidAcceptedDrayage": "{{from}}, {{origin_state}}, a {{to}}, {{destination_state}} {{value}}",
  "NOTIFICATION_createDrayage": "",
  "NOTIFICATION_steamshipUpdatedDrayage": "Se actualizó la información de la Línea Naviera.",
  "NOTIFICATION_containerUpdatedDrayage": "Detalles del nuevo contenedor",
  "NOTIFICATION_documentsAcceptedDrayage": "{{company}} firmó todos los documentos",
  "NOTIFICATION_agreementDrayage": "",
  "NOTIFICATION_documentSignedDrayage": "{{company_name}} firmó los Términos y Condiciones",
  "NOTIFICATION_shipmentInfoUpdatedDrayage": "Embarque actualizado por {{company_name}}",
  "NOTIFICATION_inviteCarrier": "{{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}}) por {{company}}",
  "NOTIFICATION_hash-generated": "",
  "NOTIFICATION_auctionStartDrayageCarrier": "{{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}}) ${{value}}",
  "NOTIFICATION_trackingDrayage": "{{city}}, {{state}} a {{destination_city}}, {{destination_state}}",
  "NOTIFICATION_deliveredDrayage": "{{city}}, {{state}} a {{destination_city}}, {{destination_state}}",
  "NOTIFICATION_extraChargeShipperRemoved": "{{company_name}} eliminó un cargo adicional.\n{{from}}, {{origin_state}}, hasta {{to}}, {{destination_state}} {{value}}",
  "NOTIFICATION_documentSignedRate": "{{origin_city}}, {{origin_state}} a {{destination_city}}, {{destination_state}} por {{company_carrier_name}}",
  "NOTIFICATION_toBook": "${{value}}, {{pickupDate}} {{from}} {{origin_state}}",
  "NOTIFICATION_updateStateCancelShipment": "{{pickupDate}} {{origin_city}}, {{origin_state}} - {{destination_city}}, ({{destination_state}}) {{company_name}} {{reason}}.",
  "NOTIFICATION_cancelShipment": "{{pickupDate}} {{origin_city}}, {{origin_state}} - {{destination_city}}, ({{destination_state}}) {{company_name}} {{reason}}.",
  "NOTIFICATION_issueReport": "El operador reportó un problema",
  "NOTIFICATION_addendumAccepted": "{{originCompany}} aceptó sus cambios.",
  "NOTIFICATION_trackingReminder": "Su dispositivo dejó de rastrear. Abra la aplicación de dexFreight.",
  "NOTIFICATION_newAgreementUploaded": "Cargó nuevos Términos y Condiciones.",
  "NOTIFICATION_newAgreementAccepted": "{{company}} aceptó sus cambios.",
  "NOTIFICATION_duplicateShipmentB2B": "¿Quieres ir al nuevo Embarque?",
  "NOTIFICATION_auctionStartSilent": "${{value}}, {{origin}} ({{origin_state}}) a {{destination}} ({{destination_state}})",
  "NOTIFICATION_bidAcceptedSilent": "${{value}}, {{from}} ({{origin_state}}) a {{to}} ({{destination_state}})",
  "NOTIFICATION_messageChat": "{{userName}} de {{companyName}}",
  "NOTIFICATION_chatDrayageNegotiation": "{{userName}} de {{companyCarrier}}",
  "NOTIFICATION_bidAcceptedDrayageChat": "{{userName}} de {{company}}",
  "NOTIFICATION_chatDrayage": "{{userName}} de {{company}}",
  "NOTIFICATION_bidDeclinedDrayage": "${{ratevalue}} - {{pickupDate}} {{originCity}}, {{originState}} - {{destinationCity}} , {{destinationState}}",
  "NOTIFICATION_trackingDrayageSilent": "{{city}}, {{state}} a {{destination_city}}, {{destination_state}}",
  "NOTIFICATION_confirmFinalCharges": "{{companyName}} confirmó cargos finales.",
  "NOTIFICATION_informationEditDrayage": "Se modificó su carga con {{companyName}}.",
  "NOTIFICATION_informationEditDrayageSilent": "Información del Flete editada {{uniqueId}}",
  "NOTIFICATION_editServicesDrayages": "{{companyName}} editó la tarifa final.",
  "NOTIFICATION_acceptedServicesDrayages": "{{companyName}} aceptó la nueva tarifa final.",
  "NOTIFICATION_generateDrayageInvoice": "¡Tu factura está lista!",
  "NOTIFICATION_bidAcceptedDrayageLog": "{{username}} de {{company}} aceptó este Embarque.",
  "NOTIFICATION_driverReassigne": "",
  "NOTIFICATION_negotiatedServicesDrayages": "",
  "NOTIFICATION_declinedServicesDrayages": "",
  "NOTIFICATION_generateBol": "{{origin_city}} ({{origin_state}}) a {{destination_city}} ({{destination_state}}) por {{company_name}}",
  "NOTIFICATION_agreementDrayageLog": "{{username}} de {{company_name}} firmó los Términos y Condiciones.",
  "NOTIFICATION_trackingDrayageLog": "{{username}} cambió el estado de {{oldstatus}} a {{newstatus}}",
  "NOTIFICATION_driverAssignedLog": "{{username}} de {{carrier_company}} asignó el operador {{driverName}} al Embarque.",
  "NOTIFICATION_TITLE_assignCarrierDrayage": "Nuevo Flete",
  "NOTIFICATION_assignCarrierDrayage": "{{company}} te ha asignado un nuevo flete",
  "NOTIFICATION_TITLE_policyExpiring": "Póliza por vencer",
  "NOTIFICATION_policyExpiring": "La póliza {{number}} de {{coverageLabel}} con {{insurerName}} vence el {{validToLabel}}.",
  "$variables": {
    "status": {
      "In route to pickup": "En ruta para carga",
      "At pickup location": "En lugar de recogida",
      "Loading": "Cargando",
      "Loaded": "Cargado",
      "In transit": "En tránsito",
      "At delivery location": "En lugar de entrega",
      "Unloading": "Descargando",
      "Delivered": "Entregado",
      "Driver is on route for pickup!": "El transportista està en ruta para carga!",
      "Driver is at pickup location!": "El transportista està en lugar de recogida!",
      "Driver is loading!": "El transportista està cargando!",
      "Shipment is loaded!": "El transportista ha cargado!",
      "Shipment is in transit!": "El transportista està en camino!",
      "Driver is in transit!": "El transportista està en camino!",
      "Driver arrived to destination!": "El transportista està en lugar de entrega!",
      "Unloading shipment!": "Descargando carga!",
      "Unloading Shipment!": "Descargando carga!",
      "Driver is on the road to pickup!": "El transportista está en ruta para carga!",
      "Driver completed loading!": "El transportista ha descargado la carga!",
      "Shipment Delivered!": "Carga entregada!",
      "PickUp": "En recogida",
      "in Transit": "En transito",
      "Delivery": "En el lugar de entrega",
      "Return": "En retorno"
    }
  }
};
